export function datesCompare(firstDate: Date, secondDate: Date) {
  return new Date(firstDate) > new Date(secondDate);
}
